// import firebase from "firebase/app";
import "firebase/firestore";
import { mapGetters } from "vuex";
import dataSources from "@/data/cloud/firebase/mixins/dataSources.js";
import storeFunctions from "@/data/functions/mixins/storeFunctions.js";
import routerFunctions from "@/data/functions/mixins/routerFunctions.js";
import announcements from "@/frame/messages/mixins/announcements.js";
import listFunctions from "@/data/functions/mixins/listFunctions.js";
import btnControl from "@/frame/animation/mixins/btnControl.js";
import describeDocument from "@/data/describe/mixins/describeDocument";

export default {
  // eslint-disable-next-line
  mixins: [
    btnControl,
    dataSources,
    announcements,
    routerFunctions,
    storeFunctions,
    listFunctions,
    describeDocument
  ],
  data() {
    return {
      results: [],
      reportsANDresults: [],
      assetDID: null,
      idi: 0,
      getLimit: 100,
      searchLimitUserAccess: 1000,
      registerLimit: 10,
      reportLimit: 25,
      totalFound: 0,
      totalSearched: 0,
      order: "",
      path: "",
      store: ""
    };
  },
  computed: {
    // eslint-disable-next-line
    ...mapGetters([
      "getUser",
      "getDataSource",
      "getCompanyDID",
      "getFacilityDID",
      "getSearchResults",
      "getOrgDetailBasic",
      "getTreeInfo"
    ])
  },
  methods: {
    // get direct
    getListDirect(db, order, sort, store, router) {
      // reset
      this.results = [];
      // let searchLimit = parseInt(this.getUser.pref.search.limit);
      let searchLimit = null;
      if (this.getUser.basic.rlic === "Unlimited") {
        searchLimit = parseInt(this.getUser.pref.search.result);
      } else {
        searchLimit = this.registerLimit;
      }
      // HELP
      // console.log("");
      // console.log("<<< GET LIST DIRECT >>>");
      // console.log("ORDER   " + order);
      // console.log("SORT    " + sort);
      // console.log("STORE   " + store);
      // console.log("ROUTER  " + router);
      // console.log("LIMIT   " + searchLimit);
      // console.log(db);

      // [2] Reset data
      // it used ot be orderBy(order, "desc")
      // eslint-disable-next-line
      db.orderBy(order, "desc").limit(searchLimit).get()
        .then(querySnapshot => {
          querySnapshot.forEach(doc => {
            // eslint-disable-next-line
            let k = doc.data();
            // console.log("HERE GET LIST");
            // console.log(k);
            this.appendList(k, "desc.newestfirst");
            // this.appendList(k, sort);
          });
        })
        // eslint-disable-next-line
        .then(doc=> {
          // console.log("GET LIST");
          // console.log(this.results);
          this.dialog = true;
          this.stopBtnSpinAll();
          if (this.results.length === 0) {
            this.btnSpinDocumentLog = false;
            this.btnSpinDocumentRevs = false;
            // SNACKBAR
            let msg = "";
            // eslint-disable-next-line
            msg = "The register is empty. Create new document.";
            this.generateInfoSnackbar(this.ui.colorBlue1, msg);
          } else {
            this.$store.dispatch("changeCommsDialog", true);
            this.$store.dispatch(store, this.results);
            // eslint-disable-next-line
            this.$store.dispatch("changeSearchResultsCounter", this.results.length);
            // this.$store.dispatch("changeCommsList", this.results);
            // console.log(">>> GET LIST RESULTS ARE READY <<<");
            // console.log(this.sortListbyIDG(this.results));
            if (router !== null) {
              // console.log("");
              // console.log("***** GO TO ROUTER ******");
              // console.log(router);
              this.$router.push(router);
            }
            // SNACKBAR
            let tag = this.results[0].basic.tag;
            let msg = "";
            msg = msg + this.defineDocumentFromTag(tag).title;
            msg = msg + " Register was loaded.";
            this.generateInfoSnackbar(this.ui.colorBlue1, msg);
          }
          // this is store update and router
        });
    },
    getListDirectCheck(db, order, sort, store, router, check) {
      // reset
      this.results = [];
      // let searchLimit = parseInt(this.getUser.pref.search.limit);
      let searchLimit = null;
      if (this.getUser.basic.rlic === "Unlimited") {
        searchLimit = parseInt(this.getUser.pref.search.result);
      } else {
        searchLimit = this.registerLimit;
      }

      // CHECK
      let checkEnable = false;
      let checkDID = null;
      // ENABLE CHECK
      if (check !== null && check !== undefined && check !== "") {
        checkEnable = true;
        checkDID = this.getUser.pref.select.fdid;
      }

      // HELP
      // console.log("");
      // console.log("<<< GET LIST DIRECT >>>");
      // console.log("ORDER      " + order);
      // console.log("SORT       " + sort);
      // console.log("STORE      " + store);
      // console.log("ROUTER     " + router);
      // console.log("LIMIT  s    " + searchLimit);
      // console.log("CHECK      " + check);
      // console.log("CHECK ENB  " + checkEnable);
      // console.log("CHECK DID  " + checkDID);
      // console.log(db);

      // [2] Reset data
      // it used ot be orderBy(order, "desc")
      // eslint-disable-next-line
      db.orderBy(order, "desc").limit(searchLimit).get()
        .then(querySnapshot => {
          querySnapshot.forEach(doc => {
            // eslint-disable-next-line
            let k = doc.data();
            // console.log("HERE GET LIST");
            // console.log(k);
            if (checkEnable === true) {
              if (k.link.fdid === checkDID) {
                this.appendList(k, "desc.newestfirst");
              }
            } else {
              this.appendList(k, "desc.newestfirst");
            }
            // this.appendList(k, sort);
          });
        })
        // eslint-disable-next-line
        .then(doc=> {
          // console.log("GET LIST");
          // console.log(this.results);
          this.dialog = true;
          this.stopBtnSpinAll();
          if (this.results.length === 0) {
            this.btnSpinDocumentLog = false;
            this.btnSpinDocumentRevs = false;
            // SNACKBAR
            let msg = "";
            // eslint-disable-next-line
            msg = "The register is empty. Create new document.";
            this.generateInfoSnackbar(this.ui.colorBlue1, msg);
          } else {
            this.$store.dispatch("changeCommsDialog", true);
            this.$store.dispatch(store, this.results);
            // eslint-disable-next-line
            this.$store.dispatch("changeSearchResultsCounter", this.results.length);
            // this.$store.dispatch("changeCommsList", this.results);
            // console.log(">>> GET LIST RESULTS ARE READY <<<");
            // console.log(this.sortListbyIDG(this.results));
            if (router !== null) {
              // console.log("");
              // console.log("***** GO TO ROUTER ******");
              // console.log(router);
              this.$router.push(router);
            }
            // SNACKBAR
            let tag = this.results[0].basic.tag;
            let msg = "";
            msg = msg + this.defineDocumentFromTag(tag).title;
            msg = msg + " Register was loaded.";
            this.generateInfoSnackbar(this.ui.colorBlue1, msg);
          }
          // this is store update and router
        });
    },
    getReportsANDResults(represObj) {
      // DEFINE
      const db = this.defineDataSourceFromTag("E8");
      let dbResult = this.db.collection("relps");
      // const sort = "NewestFirst";
      const order = "basic.idg";
      const store = "changeSearchResults";
      const router = this.defineRouter("E8");

      // reset
      this.results = [];
      this.reportsANDresults = [];
      // DEFINE SEARCH LIMIT
      let searchLimit = this.reportLimit;
      // if (this.getUser.basic.rlic === "Unlimited") {
      //   searchLimit = parseInt(this.getUser.pref.search.result);
      // } else {
      //   searchLimit = this.registerLimit;
      // }

      // HELP
      // console.log("");
      // console.log("<<< GET REPORTS AND RESULTS >>>");
      // console.log("DISCIPLINE " + represObj.dis);
      // console.log("ORDER      " + order);
      // console.log("SORT       " + sort);
      // console.log("STORE      " + store);
      // console.log("ROUTER     " + router);
      // console.log("LIMIT      " + searchLimit);
      // console.log(db);

      // [2] Reset data
      // it used ot be orderBy(order, "desc")
      // eslint-disable-next-line
      db.orderBy(order, "desc").limit(searchLimit).get()
        .then(querySnapshot => {
          querySnapshot.forEach(doc => {
            let k = doc.data();
            if (k.char.dis === represObj.dis || represObj.dis === "Other") {
              // GET RESULTS FOR THIS REPORT
              // dbResult = dbResult.doc(k.basic.did).collection("e5");
              // eslint-disable-next-line
              dbResult.doc(k.basic.did).get().then((doc) => {
                  let e5 = doc.data().e5;
                  k.result = e5;
                  // console.log(k);
                  this.appendReportsANDResults(k, "desc.newestfirst");
                });
              // console.log("HERE GET LIST");
              // console.log(dbResult);
              this.appendList(k, "desc.newestfirst");
            }
          });
        })
        // eslint-disable-next-line
        .then(doc=> {
          // console.log("GET LIST");
          // console.log(this.results);
          this.dialog = true;
          this.stopBtnSpinAll();
          if (this.results.length === 0) {
            this.btnSpinDocumentLog = false;
            this.btnSpinDocumentRevs = false;
            // SNACKBAR
            let msg = "";
            // eslint-disable-next-line
            msg = "The register is empty. Create new document.";
            this.generateInfoSnackbar(this.ui.colorBlue1, msg);
          } else {
            this.$store.dispatch("changeCommsDialog", true);
            this.$store.dispatch(store, this.results);
            // eslint-disable-next-line
            this.$store.dispatch("changeSearchResultsCounter", this.results.length);
            // this.$store.dispatch("changeCommsList", this.results);
            // console.log(">>> GET LIST RESULTS ARE READY <<<");
            // console.log(this.sortListbyIDG(this.results));
            // console.log(">>> GET LIST REPORT / RESULTS ARE READY <<<");
            // console.log(this.sortListbyIDG(this.reportsANDresults));
            if (router !== null) {
              // console.log("");
              // console.log("***** GO TO ROUTER ******");
              // console.log(router);
              this.$router.push(router);
            }
            // SNACKBAR
            let tag = this.results[0].basic.tag;
            let msg = "";
            msg = msg + this.defineDocumentFromTag(tag).title;
            msg = msg + " Register was loaded.";
            this.generateInfoSnackbar(this.ui.colorBlue1, msg);

            // STORE OVERWRITE
            // THIS IS NOT SHOWN AS SAVED IN STORE
            // get search report is empty
            this.$store.dispatch(store, this.reportsANDresults);
          }
          // this is store update and router
        });
    },
    // laod next
    loadNext() {
      // console.log("");
      // console.log("<<< LOAD NEXT >>>");
      this.btnSpinLoadMore = true;
      // DEFINE REGISTER
      // let searchLimit = parseInt(this.getUser.pref.search.limit);
      let searchLimit = null;
      if (this.getUser.basic.rlic === "Unlimited") {
        searchLimit = parseInt(this.getUser.pref.search.result);
      } else {
        searchLimit = this.registerLimit;
      }

      let lastResult = this.getSearchResults[this.getSearchResults.length - 1];
      let tag = lastResult.basic.tag;
      let arch = lastResult.basic.ver;
      // DEFINE DB
      let db = null;
      // console.log(tag);
      if (tag !== null && arch === "A") {
        db = this.defineDataSourceFromTagForArchive(tag);
      } else if (tag === "D3") {
        // console.log("HERE DB1");
        let tagd = this.getPageInfo.tag;
        db = this.defineDataSourceFromTagForRelationship("D3", tagd);
      } else if (tag === "G1") {
        // console.log("HERE DB2");
        let tagd = lastResult.basic.tagd;
        db = this.defineDataSourceFromTagForRelationship("G1", tagd);
      } else if (
        tag !== "D3" &&
        this.getOrgDetailBasic !== undefined &&
        this.getOrgDetailBasic !== null
      ) {
        // console.log("HERE DB3");
        // EMBEDDED LIST
        let embeddedTag = this.getOrgDetailBasic.tag;
        embeddedTag = embeddedTag + "." + tag;
        db = this.defineDataSourceFromTag(embeddedTag);
        // console.log("EMBEDDED LIST");
        // console.log(db);
      } else if (tag === "W1" || tag === "W2") {
        // console.log("EMBEDDED LIST WORK PLANS");
        let embeddedTag = null;
        if (
          this.getRegisterInfo !== undefined &&
          this.getRegisterInfo !== null
        ) {
          if (this.getRegisterInfo.tag === "B6") {
            embeddedTag = "B6.W";
          } else {
            embeddedTag = tag;
          }
          // ASSIGN EMEDDED DB
          db = this.defineDataSourceFromTag(embeddedTag);
        } else {
          // if this is not emebdded
          db = this.defineDataSourceFromTag(tag);
        }
        // console.log(db);
      } else if (tag === "Q1") {
        // console.log("EMBEDDED LIST Q1");
        let embeddedTag = null;
        if (
          this.getRegisterInfo !== undefined &&
          this.getRegisterInfo !== null
        ) {
          if (this.getRegisterInfo.tag === "B4") {
            embeddedTag = "B4.Q1";
          }
          // ASSIGN EMEDDED DB
          db = this.defineDataSourceFromTag(embeddedTag);
        } else {
          // if this is not emebdded
          db = this.defineDataSourceFromTag(tag);
        }
      } else if (tag === "B3") {
        // console.log("EMBEDDED LIST USER ACTIONS");
        let embeddedTag = null;
        if (
          this.getRegisterInfo !== undefined &&
          this.getRegisterInfo !== null
        ) {
          if (this.getRegisterInfo.tag === "U1") {
            embeddedTag = "U1.B3";
          }
          if (this.getRegisterInfo.tag === "C1") {
            embeddedTag = "B3";
          }
          // ASSIGN EMEDDED DB
          db = this.defineDataSourceFromTag(embeddedTag);
        } else {
          // if this is not emebdded
          db = this.defineDataSourceFromTag(tag);
        }
      } else if (tag === "M5") {
        // console.log("EMBEDDED LIST USER ACTIONS");
        let embeddedTag = null;
        if (
          this.getRegisterInfo !== undefined &&
          this.getRegisterInfo !== null
        ) {
          if (this.getRegisterInfo.tag === "F1") {
            embeddedTag = "M5";
          }
          // ASSIGN EMEDDED DB
          db = this.defineDataSourceFromTag(embeddedTag);
        } else {
          // if this is not emebdded
          db = this.defineDataSourceFromTag(tag);
        }
      } else if (tag === "B4" || tag === "B6") {
        let embeddedTag = null;
        // console.log("HERE PLAN");
        if (
          this.getRegisterInfo !== undefined &&
          this.getRegisterInfo !== null
        ) {
          if (this.getRegisterInfo.tag === "B6") {
            embeddedTag = "B6.W";
          }
          if (this.getRegisterInfo.tag === "B4") {
            embeddedTag = "B4.Q1";
          }
          // ASSIGN EMEDDED DB
          db = this.defineDataSourceFromTag(embeddedTag);
          // console.log(db);
        } else {
          // if this is not emebdded
          db = this.defineDataSourceFromTag(tag);
        }
      } else if (tag === "M5") {
        let embeddedTag = null;
        if (
          this.getRegisterInfo !== undefined &&
          this.getRegisterInfo !== null
        ) {
          if (this.getRegisterInfo.tag === "M2") {
            embeddedTag = "M2.M5";
          }
          // ASSIGN EMEDDED DB
          db = this.defineDataSourceFromTag(embeddedTag);
        } else {
          // if this is not emebdded
          db = this.defineDataSourceFromTag(tag);
        }
      } else {
        // ALL OTHER DBS
        // console.log("HERE DB");
        db = this.defineDataSourceFromTag(lastResult.basic.tag);
      }
      // LOAD DATA
      let register = this.getSearchResults;
      // reset counters
      this.totalFound = 0;
      this.totalSearched = 0;

      // console.log(" ");
      // console.log("LOAD NEXT");
      // console.log("TAG:   " + tag);
      // console.log("LIMIT  " + searchLimit);
      // console.log("LAST   " + lastResult.basic.idg);
      // console.log(db);
      // eslint-disable-next-line
      db.orderBy("basic.idg", "desc").startAfter(lastResult.basic.idg).limit(searchLimit).get()
        .then(querySnapshot => {
          querySnapshot.forEach(doc => {
            let obj = doc.data();
            // console.log("HERE");
            // console.log(obj);
            // eslint-disable-next-line
            let duplicate = this.checkForDuplicateDocument(obj.basic.did, register);
            if (duplicate === false) {
              register.push(obj);
            }
          });
        })
        // eslint-disable-next-line
        .then(doc=> {
          // ANNOUCEMENTS
          this.btnSpinLoadMore = false;
          // eslint-disable-next-line
          // SNACKBAR
          let msg = "Current";
          msg = msg + " Register was reloaded.";
          this.generateInfoSnackbar(this.ui.colorBlue1, msg);
          // UPDATE STORE
          this.$store.dispatch("changeSearchResults", register);
          this.$store.dispatch("changeSearchResultsCounter", register.length);
        });
      // console.log("");
      // console.log(">>> LOADED MORE <<<");
      // console.log("NEW REGISTER SIZE:   " + register.length);
      // console.log("SEARCH LIMIT:        " + searchLimit);
      // console.log(db);
      // console.log(lastResult);
      // console.log(register);
    },
    loadNextCheck(check) {
      // console.log("");
      // console.log("<<< LOAD NEXT >>>");
      this.btnSpinLoadMore = true;
      // DEFINE REGISTER
      // let searchLimit = parseInt(this.getUser.pref.search.limit);
      let searchLimit = null;
      if (this.getUser.basic.rlic === "Unlimited") {
        searchLimit = parseInt(this.getUser.pref.search.result);
      } else {
        searchLimit = this.registerLimit;
      }

      let lastResult = this.getSearchResults[this.getSearchResults.length - 1];
      let tag = lastResult.basic.tag;
      let arch = lastResult.basic.ver;
      // DEFINE DB
      let db = null;
      // console.log(tag);

      // CHECK
      let checkEnable = false;
      let checkDID = null;
      // ENABLE CHECK
      if (check !== null && check !== undefined && check !== "") {
        checkEnable = true;
        checkDID = this.getUser.pref.select.fdid;
      }

      // console.log("<<< LOAD NEXT CHECK >>>");
      // console.log("CHECK      " + check);
      // console.log("CHECK ENB  " + checkEnable);
      // console.log("CHECK DID  " + checkDID);
      // console.log(db);

      if (tag !== null && arch === "A") {
        db = this.defineDataSourceFromTagForArchive(tag);
      } else if (tag === "D3") {
        // console.log("HERE DB1");
        let tagd = this.getPageInfo.tag;
        db = this.defineDataSourceFromTagForRelationship("D3", tagd);
      } else if (tag === "G1") {
        // console.log("HERE DB2");
        let tagd = lastResult.basic.tagd;
        db = this.defineDataSourceFromTagForRelationship("G1", tagd);
      } else if (
        tag !== "D3" &&
        this.getOrgDetailBasic !== undefined &&
        this.getOrgDetailBasic !== null
      ) {
        // console.log("HERE DB3");
        // EMBEDDED LIST
        let embeddedTag = this.getOrgDetailBasic.tag;
        embeddedTag = embeddedTag + "." + tag;
        db = this.defineDataSourceFromTag(embeddedTag);
        // console.log("EMBEDDED LIST");
        // console.log(db);
      } else if (tag === "W1" || tag === "W2") {
        // console.log("EMBEDDED LIST WORK PLANS");
        let embeddedTag = null;
        if (
          this.getRegisterInfo !== undefined &&
          this.getRegisterInfo !== null
        ) {
          if (this.getRegisterInfo.tag === "B6") {
            embeddedTag = "B6.W";
          } else {
            embeddedTag = tag;
          }
          // ASSIGN EMEDDED DB
          db = this.defineDataSourceFromTag(embeddedTag);
        } else {
          // if this is not emebdded
          db = this.defineDataSourceFromTag(tag);
        }
        // console.log(db);
      } else if (tag === "Q1") {
        // console.log("EMBEDDED LIST Q1");
        let embeddedTag = null;
        if (
          this.getRegisterInfo !== undefined &&
          this.getRegisterInfo !== null
        ) {
          if (this.getRegisterInfo.tag === "B4") {
            embeddedTag = "B4.Q1";
          }
          // ASSIGN EMEDDED DB
          db = this.defineDataSourceFromTag(embeddedTag);
        } else {
          // if this is not emebdded
          db = this.defineDataSourceFromTag(tag);
        }
      } else if (tag === "B3") {
        // console.log("EMBEDDED LIST USER ACTIONS");
        let embeddedTag = null;
        if (
          this.getRegisterInfo !== undefined &&
          this.getRegisterInfo !== null
        ) {
          if (this.getRegisterInfo.tag === "U1") {
            embeddedTag = "U1.B3";
          }
          if (this.getRegisterInfo.tag === "C1") {
            embeddedTag = "B3";
          }
          if (this.getRegisterInfo.tag === "F1") {
            embeddedTag = "B3";
          }
          // ASSIGN EMEDDED DB
          db = this.defineDataSourceFromTag(embeddedTag);
        } else {
          // if this is not emebdded
          db = this.defineDataSourceFromTag(tag);
        }
      } else if (tag === "M5") {
        // console.log("EMBEDDED LIST USER ACTIONS");
        let embeddedTag = null;
        if (
          this.getRegisterInfo !== undefined &&
          this.getRegisterInfo !== null
        ) {
          if (this.getRegisterInfo.tag === "F1") {
            embeddedTag = "M5";
          }
          // ASSIGN EMEDDED DB
          db = this.defineDataSourceFromTag(embeddedTag);
        } else {
          // if this is not emebdded
          db = this.defineDataSourceFromTag(tag);
        }
      } else if (tag === "B4" || tag === "B6") {
        let embeddedTag = tag;
        // console.log("HERE PLAN");
        if (
          this.getRegisterInfo !== undefined &&
          this.getRegisterInfo !== null
        ) {
          if (this.getRegisterInfo.tag === "B6") {
            embeddedTag = "B6.W";
          }
          if (this.getRegisterInfo.tag === "B4") {
            embeddedTag = "B4.Q1";
          }
          // ASSIGN EMEDDED DB
          db = this.defineDataSourceFromTag(embeddedTag);
          // console.log(db);
        } else {
          // if this is not emebdded
          db = this.defineDataSourceFromTag(tag);
        }
      } else if (tag === "M5") {
        let embeddedTag = null;
        if (
          this.getRegisterInfo !== undefined &&
          this.getRegisterInfo !== null
        ) {
          if (this.getRegisterInfo.tag === "M2") {
            embeddedTag = "M2.M5";
          }
          // ASSIGN EMEDDED DB
          db = this.defineDataSourceFromTag(embeddedTag);
        } else {
          // if this is not emebdded
          db = this.defineDataSourceFromTag(tag);
        }
      } else {
        // ALL OTHER DBS
        // console.log("HERE DB");
        db = this.defineDataSourceFromTag(lastResult.basic.tag);
      }
      // LOAD DATA
      let register = this.getSearchResults;
      // reset counters
      this.totalFound = 0;
      this.totalSearched = 0;

      // console.log(" ");
      // console.log("LOAD NEXT");
      // console.log("TAG:   " + tag);
      // console.log("LIMIT  " + searchLimit);
      // console.log("LAST   " + lastResult.basic.idg);
      // console.log(db);
      // eslint-disable-next-line
      db.orderBy("basic.idg", "desc").startAfter(lastResult.basic.idg).limit(searchLimit).get()
        .then(querySnapshot => {
          querySnapshot.forEach(doc => {
            let obj = doc.data();
            // console.log("HERE");
            // console.log(obj);
            // eslint-disable-next-line
            let duplicate = this.checkForDuplicateDocument(obj.basic.did, register);
            if (duplicate === false) {
              if (checkEnable === true) {
                if (obj.link.fdid === checkDID) {
                  register.push(obj);
                }
              } else {
                register.push(obj);
              }
            }
          });
        })
        // eslint-disable-next-line
        .then(doc=> {
          // ANNOUCEMENTS
          this.btnSpinLoadMore = false;
          // eslint-disable-next-line
          // SNACKBAR
          let msg = "Current";
          msg = msg + " Register was reloaded.";
          this.generateInfoSnackbar(this.ui.colorBlue1, msg);
          // UPDATE STORE
          this.$store.dispatch("changeSearchResults", register);
          this.$store.dispatch("changeSearchResultsCounter", register.length);
        });
      // console.log("");
      // console.log(">>> LOADED MORE <<<");
      // console.log("NEW REGISTER SIZE:   " + register.length);
      // console.log("SEARCH LIMIT:        " + searchLimit);
      // console.log(db);
      // console.log(lastResult);
      // console.log(register);
    },
    // get access for user / company / facility / etc
    getListAccess(tagd, tags) {
      // console.log("GET LIST USER ACCESS");
      // console.log(tagd);
      // console.log(tags);
      this.results = []; // reset search
      // Get Database
      let store = this.defineStore("G1"); // G1
      let router = this.defineRouter("G1"); // C1
      let db = this.defineDataSourceFromTagForRelationship("G1", tagd);
      // let searchLimit = this.getLimit;
      let searchLimit = 100;
      let searchDid = null;
      let query = "";
      // search
      if (tagd === "C1" && tags === "U1") {
        query = "select.cdid";
        searchDid = this.getCompanyDID;
      }
      if (tagd === "Z5" && tags === "C1") {
        query = "select.fdid";
        searchDid = ""; // search for blank fid
      }
      if (tagd === "U1" && tags === "C1") {
        query = "select.fdid";
        searchDid = ""; // search for blank fid
      }
      if (tagd === "F1" && tags === "U1") {
        query = "select.fdid";
        searchDid = this.getFacilityDID;
      }
      if (tagd === "U1" && tags === "F1") {
        query = "select.cdid";
        searchDid = this.getCompanyDID;
      }

      // HELP
      // console.log("GET LIST USER ACCESS");
      // console.log(tagd);
      // console.log(tags);
      // console.log(db);
      // console.log(store);
      // console.log(router);
      // search item convet to lower case
      // eslint-disable-next-line
      db.where(query, "==" , searchDid).where("basic.tags", "==", tags).limit(searchLimit).get()
        .then(querySnapshot => {
          querySnapshot.forEach(doc => {
            // eslint-disable-next-line
            let docData = doc.data();
            let obj = Object.assign({}, docData);
            this.results.push(obj);
          });
        })
        // eslint-disable-next-line
        .then(doc=> {
          // console.log("USER ACCESS LIST");
          // console.log(this.results);
          // console.log(this.results.length);
          this.$store.dispatch(store, this.results);
          this.btnSpinAdminReview = false;
          if (this.results.length > 0) {
            this.$router.push(router);
          } else {
            this.btnSpinAdminReview = false;
          }
          // SNACKBAR
          let msg = null;
          if (this.results.length > 0) {
            msg = "User Access list was loaded.";
          } else {
            msg = "No user active access list is assigned.";
          }
          this.generateInfoSnackbar(this.ui.colorBlue1, msg);
        });
    },
    // only used for user sign in
    getUserAccess() {
      this.results = []; // reset search
      // Get Database
      let dbs = this.defineDataSourceFromTagForRelationship("G1", "U1");
      // search item convet to lower case
      // eslint-disable-next-line
      dbs.orderBy("basic.did").limit(this.searchLimitUserAccess).get()
        .then(querySnapshot => {
          querySnapshot.forEach(doc => {
            // eslint-disable-next-line
            let docData = doc.data();
            let obj = Object.assign({}, docData);
            this.results.push(obj);
          });
        })
        // eslint-disable-next-line
        .then(doc=> {
          // console.log("USER ACCESS LIST");
          // console.log(this.results);
          // console.log(this.results.length);
          this.$store.dispatch("changeUserAccessList", this.results);
        });
    },
    appendList(u, type) {
      var obj = Object.assign({}, u);
      let temp = this.results;
      if (type === "NewestFirst") {
        temp.unshift(obj);
        // console.log(temp);
      }
      if (type === "NewestLast") {
        temp.push(obj);
      }
      if (type === "desc.newestfirst") {
        // console.log(temp);
        temp.push(obj);
      }
      this.results = temp;
    },
    appendReportsANDResults(u, type) {
      var obj = Object.assign({}, u);
      let temp = this.reportsANDresults;
      if (type === "NewestFirst") {
        temp.unshift(obj);
        // console.log(temp);
      }
      if (type === "NewestLast") {
        temp.push(obj);
      }
      if (type === "desc.newestfirst") {
        // console.log(temp);
        temp.push(obj);
      }
      this.reportsANDresults = temp;
    },
    appendTree(u) {
      var obj = Object.assign({}, u);
      let temp = this.results;
      temp.push(obj);
      this.results = temp;
    },
    getRelpsRemoteThenPageDetail(detail, page) {
      // GET Relationshiop for Detail
      const db = this.defineDataSourceFromTag("G6");
      let did = detail.basic.did;
      let t = this;
      // eslint-disable-next-line
      db.doc(did).get().then((doc) => {
          console.log(doc.data());
          // SAVE RELPS to STORE
          // console.log(">>> SAVE RELPS REMOTE TO STORE");
          t.$store.dispatch("changeRelpsRemote", doc.data());
          // SAVE DETAIL to STORE
          // console.log(">>> SAVE DATA TO STORE");
          // console.log(detail);
          t.saveToStore(detail);
          // LOAD Router
          // console.log(">>> GO TO PAGE");
          // console.log(page);
          t.$router.push(page);
        })
        .catch(error => {
          t.showSnackbar(error.message, "error");
        });
    },
    // get direct
    getTreeAsset(did) {
      // SET DB
      this.results = null;
      let treeRelps = null;
      const dbRelps = this.defineDataSourceFromTag("G6");
      const dbAsset = this.defineDataSourceFromTag("A1");

      // HELP
      // console.log("");
      // console.log(">>> GET TREE ASSET <<< ");
      // console.log("DID: " + did);
      // console.log(dbRelps);
      // console.log(dbAsset);
      // eslint-disable-next-line
      dbRelps.doc(did).get().then((doc) => {
          if (doc.exists) {
            treeRelps = doc.data().a1;
            // CHECK IF treeRelps has any elements
            if (treeRelps.length > 0) {
              this.results = [];
              for (var i = 0; i < treeRelps.length; i++) {
                let didAsset = treeRelps[i].did;
                // eslint-disable-next-line
                dbAsset.doc(didAsset).get().then((doc) => {
                    if (doc.exists) {
                      let k = doc.data();
                      this.appendTree(k);
                    }
                  });
              }
            }
          }
        })
        .then(() => {
          // ASSET PARENT
          // eslint-disable-next-line
          dbAsset.doc(did).get().then((doc) => {
              if (doc.exists && this.results !== null) {
                // NEW PARENT
                let link = doc.data().link;
                let info = this.generateTreeParentInfo(link);
                this.$store.dispatch("changeTreeParentInfo", info);
                // NEW MASTER
                let tree = this.generateTreeInfo(doc.data().basic);
                let assetDID = doc.data().basic.did;
                this.$store.dispatch("changeTreeMasterInfo", tree);
                this.$store.dispatch("changeTreeInfo", tree);
                this.$store.dispatch("changeAssetDID", assetDID);
              } else {
                this.$store.dispatch("changeTreeParentInfo", null);
              }
            });
        })
        .then(() => {
          this.dialog = true;
          this.stopBtnSpinAll();
          if (this.results === null) {
            // SNACKBAR
            let msg = "";
            msg = "The asset tree structure is empty.";
            this.generateInfoSnackbar(this.ui.colorBlue1, msg);
          } else {
            // STORE
            let store = "changeSearchResults";
            let storeCtr = "changeSearchResultsCounter";
            this.$store.dispatch(store, this.results);
            this.$store.dispatch(storeCtr, this.results.length);
            // MASTER TREE
            let tree = this.getTreeInfo;
            this.$store.dispatch("changeTreeMasterInfo", tree);
            // ROUTER
            if (this.results !== null) {
              this.$router.push("/treeview");
            }
            // SNACKBAR
            let msg = "";
            msg = "The asset tree was loaded.";
            this.generateInfoSnackbar(this.ui.colorBlue1, msg);
          }
        });
    }
  }
};
